'use client'

import { FacetSelectorLayout } from '@src/components/ProductConfigurator/modules/FacetSelect/FacetSelectLayout'
import { RadioSelectLayout } from '@src/components/ProductConfigurator/modules/RadioSelect/RadioSelectLayout'

export const FACET_LAYOUT_META: FacetLayoutMeta = {
  default: FacetSelectorLayout,
  subscriptionFrequency: RadioSelectLayout,
}
interface FacetRendererProps {
  facetMeta: FacetMeta[]
  facetOptions: Record<string, FacetOption[]>
  setFacetOption: (key: string, option: FacetOption) => void
}

export const FacetRenderer = ({ facetMeta, facetOptions, setFacetOption }: FacetRendererProps) => {
  return facetMeta.map((facet) => {
    return FACET_LAYOUT_META[facet.layout]({
      facetMeta: facet,
      facetOptions: facetOptions[facet.key],
      setFacetOption,
    })
  })
}
